export enum RolesEnum {
  ADMIN = 'ADMIN',
  EXPERT = 'EXPERT',
  PATIENT = 'PATIENT',
}
